import { ShippingContactContext as IShippingContactContext } from 'common/interface';
import { createContext, useState } from 'react';

const ShippingContactContext = createContext<IShippingContactContext>(null as any);

const ShippingContactContextProvider = ({ children, initialValue = false }: any) => {
  const [showShippingForm, setShowShippingForm] = useState(initialValue);

  return (
    <ShippingContactContext.Provider
      value={{
        showShippingForm,
        setShowShippingForm,
      }}
    >
      {children}
    </ShippingContactContext.Provider>
  );
};

export { ShippingContactContext, ShippingContactContextProvider };
